import { INITIAL_STATE } from './constants';

export function getCursor(state, name) {
  if (!state.get('cursors')) return state.get(name, INITIAL_STATE);
  return state.getIn(['cursors', name], INITIAL_STATE);
}
